import Protocol from './protocol.json';

export default Protocol;
